module.exports = __webpack_public_path__ + "static/img/group-6@3x.b41c97b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/group-6@3x.jpg
// module id = /o/C
// module chunks = 1